import React from 'react';

const SkipToContent = () => {
  const skipToMainContent = () => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
      
      // Announce to screen readers
      const announcement = document.getElementById('announcements');
      if (announcement) {
        announcement.textContent = 'تم الانتقال إلى المحتوى الرئيسي';
        setTimeout(() => {
          announcement.textContent = '';
        }, 3000);
      }
    }
  };

  return (
    <button
      onClick={skipToMainContent}
      className="sr-only focus:not-sr-only fixed top-4 left-4 z-[9999] bg-blue-600 text-white px-4 py-2 rounded-lg font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 transition-all duration-300 hover:bg-blue-700 active:bg-blue-800"
      tabIndex={0}
      aria-label="تخطي إلى المحتوى الرئيسي"
      
    >
      Skip to main content
    </button>
  );
};

export default SkipToContent;
